var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }